import { changeReasons } from '@/mocks/home';

export default function ReasonSection() {
  return (
    <section id="reason" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-700 bg-primary-100 px-3 py-1.5 rounded-full">
            <i className="ri-refresh-line"></i>
            地址变动
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
            为什么会频繁出现「最新地址」
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            地址并非无缘无故地更换。理解背后的常见原因，能帮你判断眼前的入口是否值得信任，
            也能在遇到打不开的情况时保持冷静，而不是急着点开任何看起来像入口的链接。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {changeReasons.map((item, index) => (
            <div
              key={item.title}
              className="relative rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-7 hover:border-primary-300 transition-colors"
            >
              <span className="absolute top-6 right-6 font-heading text-3xl text-background-300 select-none">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-lg bg-accent-50 border border-accent-200 p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-5">
          <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
            <i className="ri-compass-discover-line text-2xl"></i>
          </span>
          <div>
            <h3 className="font-heading text-lg text-accent-950">记住一个原则：先核实，再访问</h3>
            <p className="mt-2 text-sm leading-relaxed text-accent-900/85">
              地址会变，判断的方法不会变。只要坚持从官方渠道确认入口，不轻信来路不明的转发，
              就能在地址频繁变动的环境里始终保持主动。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}